import React from 'react';

interface IZpracovaneZadosti {}

const ZpracovaneZadosti: React.FC<IZpracovaneZadosti> = () => {
    return <></>;
};

export default ZpracovaneZadosti;
